export default __webpack_public_path__ + "static/media/bgplayback-v4.3.73cea700.mp4";